import {
  OurIngredientsRoot,
  SectionTitle,
  OurIngredientsContainer,
  IngredientsColumn,
  RecipeLabel,
  IngredientsFlex,
  ButtonWrapper,
} from './OurIngredients.styles'
import { useTranslation } from 'hooks/useTranslation'
import {
  InformationCollapse,
  InformationCollapseType,
} from 'components/InformationCollapse'
import { nutritionFormatter } from 'features/Recipes/utils/nutritionFormatter'
import { NUTRITION_FREEZE_DRIED } from 'fixtures/nutrition'
import { FreezeDriedProteins } from 'models/Pet'
import { Button } from 'components/Button'
import Link from 'next/link'

export const OurIngredients = () => {
  const { t } = useTranslation()

  const chickenNutrition = nutritionFormatter(NUTRITION_FREEZE_DRIED[FreezeDriedProteins.CHICKEN])
  const beefNutrition = nutritionFormatter(NUTRITION_FREEZE_DRIED[FreezeDriedProteins.BEEF])

  const infoList: InformationCollapseType[] = [
    {
      label: 'recipes:hero-v2.ingredients',
      description: 'recipes:ingredients-description',
    },
    {
      label: 'recipes:hero-v2.nutritional-information',
      description: 'recipes:freeze-dried.nutrition-description',
    },
  ]

  return (
    <OurIngredientsRoot>
      <OurIngredientsContainer>
        <SectionTitle>{t('products-v2:freeze-dried-box.our-ingredients.header')}</SectionTitle>
        <IngredientsFlex>
          <IngredientsColumn>
            <RecipeLabel>{t('products-v2:freeze-dried-box.our-ingredients.chicken')}</RecipeLabel>
            <InformationCollapse transValues={chickenNutrition} v2 infoList={infoList} />
          </IngredientsColumn>
          <IngredientsColumn>
            <RecipeLabel>{t('products-v2:freeze-dried-box.our-ingredients.beef')}</RecipeLabel>
            <InformationCollapse transValues={beefNutrition} v2 infoList={infoList} />
          </IngredientsColumn>
        </IngredientsFlex>
        <ButtonWrapper>
          <Link href="#hero">
            <Button>{t('products-v2:freeze-dried-box.our-ingredients.cta-button')}</Button>
          </Link>
        </ButtonWrapper>
      </OurIngredientsContainer>
    </OurIngredientsRoot>
  )
}
